import Translation from "./Translation";

const TRANSLATIONS_EN = {
  Translation,
};
export default TRANSLATIONS_EN;
